import React, { useState, useEffect} from 'react';
import _ from 'underscore';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import { convertFromAdModel, getMultiImagesFromMTAssetsAsync } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';
import { DisplayPlusNativeForm } from './display-plus-native-form';
import { edmCampaign } from '@bingads-webui/edm-campaign';

const getCampaignBiddingScheme = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .get({
      select: ['BiddingScheme'],
    })
    .toPromise();

const modelToViewModel = (ad, campaignId, adGroupId) => {
  const Id = _.get(ad, ['Id'], '');

  const Campaign = {
    Id: campaignId,
  };

  const AdGroup = {
    Id: adGroupId,
  };

  return {
    ...convertFromAdModel(ad, false),
    Campaign,
    AdGroup,
    Id: Id.toString(),
  };
};

export const DisplayPlusNative = (props) => {
  const {
    data: mtData,
    isCleaning,
    onCleaningComplete,
    campaignId,
    adGroupId,
    cid,
    aid,
    permissions,
    supportImageFitting,
  } = props;


  const [data, setData] = useState(mtData && mtData.Id ? modelToViewModel(mtData, campaignId, adGroupId) : mtData);
  const [biddingScheme, setBiddingScheme] = useState(null);

  const isBoostCampaign = permissions.dynamic.DisplayPlusAmplify && permissions.IsAmplifyEnabled;

  useEffect(() => {
    if (data && data.Images && _.isArray(data.Images)) {
      const isLegacyResponsiveAd = data && data.LegacyResponsiveAd;
      const fetchImagesPromise = getMultiImagesFromMTAssetsAsync(
        odata,
        `/Customers(${cid})/Accounts(${aid})/`,
        data.Images,
        true, // isAdCreatorEnabled,
        true, // isImproveMMA,
        !isBoostCampaign, // isMMAV2Enabled,
        isBoostCampaign, // isBoostPortraitImageEnabled,
        false, // isBoost200x100ImageEnabled
        false, // isBoostNewAspectRatioSupportEnabled
        supportImageFitting && !isBoostCampaign && !isLegacyResponsiveAd, // isImageFittingEnabled
      );

      fetchImagesPromise.then((images) => {
        _.each(images, (image) => {
          _.each(image, (i) => {
            if (i.Id) {
              i.idString = i.Id.toString();
            }
          });
        });

        setData((prevData) => ({
          ...prevData,
          Images: {
            ImageList: images,
          },
        }));
      });
    }
  }, []);

  useEffect(() => {
    if (isCleaning) {
      setData({
        isValid: false,
        isDirty: false,
        currentPageIndex: 1,
      });

      onCleaningComplete();
    }
  }, [isCleaning]);

  useEffect(() => {
    if (cid && aid && campaignId && !biddingScheme) {
      getCampaignBiddingScheme(cid, aid, campaignId)
        .then((campaign) => {
          setBiddingScheme(campaign.BiddingScheme.Type);
        });
    }
  }, [cid, aid, campaignId]);

  return (
    <>
      {!isCleaning &&
        <DisplayPlusNativeForm
          {...props}
          biddingScheme={biddingScheme}
          data={data}
          setAds={setData}
          supportImageFitting={supportImageFitting}
        />
      }
    </>
  );
};
